var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-detailed-project-view',{attrs:{"title":"Green Hollow","isYoutubeVideo":"","source":"https://www.youtube.com/embed/oRDmIZT9H9s?si=bQgdyXkHMpaIEXti&loop=1&controls=1&autoplay=1&mute=1","demoType":"download","text":_vm.formattedText}})}
var staticRenderFns = []

export { render, staticRenderFns }